import { render, staticRenderFns } from "./Certificacoes.vue?vue&type=template&id=1e8dc249&scoped=true"
import script from "./Certificacoes.vue?vue&type=script&lang=js"
export * from "./Certificacoes.vue?vue&type=script&lang=js"
import style0 from "./Certificacoes.vue?vue&type=style&index=0&id=1e8dc249&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8dc249",
  null
  
)

export default component.exports